import React, { useState } from 'react';
import { Colors, PrimaryButton, RadioGroup, Text } from 'library';
import { FilterList } from '@mui/icons-material';
import { Grid, Popover } from '@mui/material';

const educationOptions = {
    'High School Diploma': null,
    CDA: { qualification_name: 'CDA', value: 'true' },
    "Associate's Degree": { qualification_name: 'Education', option_value: "Associate's Degree" },
    "Bachelor's Degree": { qualification_name: 'Education', option_value: "Bachelor's Degree" },
};

const experienceOptions = {
    'Building Experience (0-1 years)': { qualification_name: 'Years Experience', value: '0' },
    'Intermediate Experience (1-5 years)': { qualification_name: 'Years Experience', value: '1' },
    'Proficient Experience (5+ years)': { qualification_name: 'Years Experience', value: '5' },
};

export const defaultFilters = {
    education: {},
    experience: {},
};

export interface StaffFilterOptions {
    education: { [key: string]: string | null };
    experience: { [key: string]: string | null };
}

export default function StaffFilter({
    filters,
    search,
}: {
    filters: StaffFilterOptions;
    search: (filters: StaffFilterOptions) => void;
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    return (
        <>
            <PrimaryButton
                onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                }}
                startIcon={<FilterIcon />}
                buttonStyle={{ height: 55, maxWidth: 160, width: 'auto' }}
                textStyle={{ fontSize: 20 }}
            >
                Filter
            </PrimaryButton>
            <Popover
                open={!!anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: -8, horizontal: 160 }}
                slotProps={{ paper: { style: { borderRadius: 18, padding: 30 } } }}
            >
                <Grid container direction="column" gap={1}>
                    <Text variant="body1" bold>
                        Education
                    </Text>
                    <RadioGroup
                        value={JSON.stringify(filters.education)}
                        values={Object.fromEntries(
                            Object.entries(educationOptions).map(([key, value]) => [JSON.stringify(value), key]),
                        )}
                        setValue={(value) => {
                            search({
                                ...filters,
                                education: JSON.parse(value),
                            });
                        }}
                    />
                    <Text variant="body1" bold textStyle={{ marginTop: 10 }}>
                        Experience Level
                    </Text>
                    <RadioGroup
                        value={JSON.stringify(filters.experience)}
                        values={Object.fromEntries(
                            Object.entries(experienceOptions).map(([key, value]) => [JSON.stringify(value), key]),
                        )}
                        setValue={(value) => {
                            search({
                                ...filters,
                                experience: JSON.parse(value),
                            });
                        }}
                    />
                </Grid>
            </Popover>
        </>
    );
}

function FilterIcon() {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: Colors.white,
                width: 30,
                height: 30,
                borderRadius: 15,
                padding: 2,
                marginRight: 10,
            }}
        >
            <FilterList htmlColor={Colors.darkNavy} />
        </div>
    );
}
